import React from 'react'
import ProgressRing, {
	type ProgressRingSize,
} from '@adsk/alloy-react-progress-ring'
import styled from 'styled-components'

interface ProgressRingComponentProps {
	size?: ProgressRingSize
	style?: React.CSSProperties
	message?: React.ReactNode
}

const FlexDiv = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`
const ProgressRingComponent: React.FC<ProgressRingComponentProps> = ({
	size,
	style,
	message,
}: ProgressRingComponentProps): JSX.Element => {
	const ringSize = size ?? ProgressRing.SIZES.MEDIUM
	const ProgressRingWithMessage = (): JSX.Element => {
		return (
			<>
				<FlexDiv>
					<ProgressRing
						data-testid={'progress-ring'}
						size={ringSize}
						style={{
							marginBottom: '1rem',
							...style,
						}}
					/>
					{message}
				</FlexDiv>
			</>
		)
	}

	return message !== null ? (
		<ProgressRingWithMessage />
	) : (
		<ProgressRing size={ringSize} style={{ ...style }} />
	)
}

export default ProgressRingComponent
